module.exports = __webpack_public_path__ + "img/stress_estimate1.3855c1ab.png";